import compliancePng from './assets/shield-compliance.png'
import styles from './ComplianceIcon.module.scss'
import { Tooltip, TooltipContent, TooltipTrigger } from './ui/Tooltip'

export default function ComplianceIcon() {
  return (
    <Tooltip>
      <TooltipTrigger>
        <img className={styles.complianceIcon} src={compliancePng} alt='Icon for criteria required to be compliant' height={20} width={20} />
      </TooltipTrigger>
      <TooltipContent>Compliance Criteria</TooltipContent>
    </Tooltip>
  )
}
